import { register } from 'swiper/element/bundle';

// Registrar Swiper Element (Web Component)
register();

import('./bootstrap').catch((err) => console.error(err));